import { useRouter } from 'next/router';

export const getPathWithRouter = (name) => {
    const router = useRouter();
    return router.query[name] === "true";
}